export const iconFontAwesomeReligionMenorah = (
	<i className="fa-solid fa-menorah"></i>
);
